import React, { useEffect, useState } from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { hiddenContentStyle, mergeStyles } from "@fluentui/react/lib/Styling";
import { useId } from "@fluentui/react-hooks";
import { isNullOrWhiteSpace } from "../../functions/stringFormatter";
import { useCommonControlsStyle } from "../../theme/styles/CommonControlsStyle";
import AdvSearchObjectSearch from "./AdvSearchObjectSearch";
import { PROGRESS_STATUS, DATA_LOAD_STATUS } from "../../redux/constants/metaData";
import { useCheckin } from "../../redux/hooks/useCheckin";
import { useMetadata } from "../../redux/hooks/useMetadata";
import { useTools } from "../../redux/hooks/useTools";

const AdvSearchObjectModel = () => {
  const { selectedKeyLuName } = useCheckin();
  const { advSearchMedatDataStatus } = useMetadata();
  const {
    onAdvObjSearchModelHide,
    onAdvObjRowSelected,
    onWhereClauseChange,
    onAdvObjResultsStatusChanged,
    onAdvObjMetaDataStatusChanged,
  } = useTools();
  const labelId = useId("dialogLabel");
  const subTextId = useId("subTextLabel");

  const [btnAdvSearchEnabled, setBtnAdvSearchEnabled] = useState(
    isNullOrWhiteSpace(selectedKeyLuName)
  );
  const [newWidth, setNewWidth] = useState(400);
  const [preWidth, setPreWidth] = useState(400);

  const styleTheme = useCommonControlsStyle();
  const screenReaderOnly = mergeStyles(hiddenContentStyle);
  const handlerResize = () => {
    setNewWidth(window.outerWidth);
  };

  useEffect(() => {
    setNewWidth(window.outerWidth);
    setPreWidth(window.outerWidth);
    window.addEventListener("resize", handlerResize);

    return () => {
      window.removeEventListener("resize", handlerResize);
    };
  }, []);

  useEffect(() => {
    setBtnAdvSearchEnabled(isNullOrWhiteSpace(selectedKeyLuName));
  }, [selectedKeyLuName]);

  function openSearchDialog() {
    onAdvObjSearchModelHide(false);
    onAdvObjRowSelected(null);
    onWhereClauseChange("");
    onAdvObjResultsStatusChanged(PROGRESS_STATUS.onLoad);
    if (
      advSearchMedatDataStatus !== DATA_LOAD_STATUS.completed &&
      !isNullOrWhiteSpace(selectedKeyLuName)
    ) {
      onAdvObjMetaDataStatusChanged(DATA_LOAD_STATUS.onLoad);
    }
  }

  return (
    <>
      <PrimaryButton
        text="Search"
        style={
          btnAdvSearchEnabled === true
            ? styleTheme.DisableButtoneStyle
            : styleTheme.PrimaryButtonFillStyle
        }
        onClick={openSearchDialog}
        disabled={btnAdvSearchEnabled}
      />
      <label id={labelId} className={screenReaderOnly}></label>
      <label id={subTextId} className={screenReaderOnly} />
      <AdvSearchObjectSearch />
    </>
  );
};

export default AdvSearchObjectModel;
